import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { BarLoader } from 'react-spinners';
import FilterForm from './FilterForm';
import GridList from './GridList';

class AppetiteProduct extends React.Component {
  render() {
    const { industries, toggleFilter, isFilterOpen } = this.props;
    const ln = industries.length;

    return (
      <Fragment>
        <section className="wrapper filter__wrap--mob">
          <button
            className="appetite__trigger appetite__trigger--mob"
            onClick={toggleFilter}
          >
            Filter &nbsp;
            <i className="fas fa-chevron-down" />
          </button>
          <section className={`appetite__wrap ${isFilterOpen ? 'is-active' : ''}`}>
            {isFilterOpen && (
              <FilterForm {...this.props} toggleFilter={toggleFilter} formMode="Mob" />
            )}
          </section>
        </section>
        <section className="appetite__grid main--product">
          <div className="accordion__content-wrapper container">
            <section className="grid">
              {ln > 0 ? (
                industries
                  .sort((a, b) => {
                    const initial = a.name.toLowerCase();

                    const next = b.name.toLowerCase();
                    if (initial < next) return -1;
                    if (initial > next) return 1;
                    return 0;
                  })
                  .map((industry, i) => (
                    <GridList
                      {...this.props}
                      industry={industry.id}
                      sectors={industry.sectors}
                      name={industry.name}
                      items={industries[i].squares}
                      key={i}
                    />
                  ))
              ) : (
                <div className="spinner-holder">
                  <BarLoader color="#150F96" />
                </div>
              )}
            </section>
          </div>
        </section>
      </Fragment>
    );
  }
}

export default AppetiteProduct;



// WEBPACK FOOTER //
// ./src/components/AppetiteProduct.js